import { createAsyncThunk } from '@reduxjs/toolkit';
import statisticApi from '~/apis/statistic';
import { GET_STATISTIC_SUMMARY } from '~/utils/constants/actionType';

export const getTotalStatistic = createAsyncThunk(GET_STATISTIC_SUMMARY, async (_, { rejectWithValue }) => {
  try {
    const res = await statisticApi.getTotalStatistic();
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
